document.addEventListener('DOMContentLoaded', () => {
	var image = document.querySelector('.stats .clouds img')
	new simpleParallax(image, {
		// scale: 1.5,
		orientation: 'down',
	})
})
